
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.688 5.688H.875a.875.875 0 000 1.75h4.813v4.812a.875.875 0 001.75 0V7.437h4.812a.875.875 0 000-1.75H7.437V.875a.875.875 0 00-1.75 0v4.813z","fill":"url(#paint0_linear_6_1072)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_6_1072","x1":"5.789","y1":"13.125","x2":"4.774","y2":"1.964","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FF7805"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FFA702"}})])])])
          )
        }
      }
    